import { getCustomCalendarMapForColumn } from '@thoughtspot/visualization-column-util';
import _ from 'lodash';
import { isSinglePointKPIEnabledWithValue } from '../components/kpi/kpi-utils';
import { getVisualizedColumns } from '../core/chart-model-utils';
import { getDataArray } from '../data/data-util';
import { ChartDataModel, HighchartDataModel, } from '../highcharts/highchart-data-model';
import { createLogger } from '../utils/logger';
const logger = createLogger('reactchart-data-model');
export class ReactChartDataModel extends ChartDataModel {
    constructor(_chartModel, data, _queryDefinitions, _options, chartOptions, getEventMap) {
        super();
        this._chartModel = _chartModel;
        this.data = data;
        this._queryDefinitions = _queryDefinitions;
        this._options = _options;
        this.displayToCustomCalendarValueMap = {};
        this.dataArray = getDataArray(data);
        try {
            const columns = getVisualizedColumns(this._chartModel);
            if (columns.length > 1 ||
                isSinglePointKPIEnabledWithValue(this._chartModel)) {
                this._highchartDataModel = new HighchartDataModel(this._chartModel, this.data, this._queryDefinitions, this._options, chartOptions, getEventMap);
            }
        }
        catch (e) {
            logger.warn('highchart data model generation was erroneous', e);
        }
    }
    getDisplayCustomCalendarMapForColumn(column) {
        return getCustomCalendarMapForColumn(column, this.displayToCustomCalendarValueMap);
    }
    get hasNoData() {
        return _.isEmpty(this.data);
    }
    get series() {
        var _a;
        return (_a = this._highchartDataModel) === null || _a === void 0 ? void 0 : _a.series;
    }
    get _seriesMap() {
        var _a;
        return (_a = this._highchartDataModel) === null || _a === void 0 ? void 0 : _a._seriesMap;
    }
    getDataArray() {
        return this.dataArray;
    }
    getHighchartDatamodel() {
        return this._highchartDataModel;
    }
}
//# sourceMappingURL=react-chart-data-model.js.map